import type { ReactNode } from "react";
import clsx from "clsx";

const AlertInfo = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className="rounded-md bg-gray-light  px-4 py-3">
      <span className="font-bold text-blue">{title}: </span>
      <span>{description}</span>
    </div>
  );
};

export default AlertInfo;
